import React from "react";
import { Check, Sparkles } from "lucide-react";
import { PLANS } from "../data/site";

export default function Plans() {
  return (
    <section id="plans" data-testid="plans-section" className="relative bg-ink text-cream py-24 md:py-32 px-5 md:px-10 lg:px-16 overflow-hidden">
      <div aria-hidden className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-grape/20 blur-[160px] pointer-events-none" />

      <div className="relative z-10 grid grid-cols-12 gap-6 mb-16 items-end">
        <div className="col-span-12 md:col-span-8">
          <div className="inline-flex items-center gap-2 bg-lime/10 border border-lime/30 rounded-full px-4 py-2 mb-6">
            <Sparkles size={14} className="text-lime" />
            <span className="font-body text-xs tracking-widest uppercase text-lime">Planos</span>
          </div>
          <h2 className="font-display font-extrabold text-5xl md:text-7xl leading-[0.92]">
            três <span className="text-lime">caminhos</span>.
            <br />uma intenção.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-4">
          <p className="font-body text-base text-cream/70">
            Ajustamos cada plano à tua realidade. Se nenhum encaixa, fazemos um à medida.
          </p>
        </div>
      </div>

      <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-6">
        {PLANS.map((plan, idx) => {
          const is360 = plan.name === "360";
          return (
          <div
            key={plan.name}
            data-testid={`plan-${plan.name.toLowerCase()}`}
            className={`relative p-8 rounded-3xl flex flex-col border-2 transition-transform duration-300 hover:-translate-y-2 ${
              plan.featured
                ? "bg-lime text-ink border-lime md:-translate-y-4"
                : is360
                ? "text-cream border-white/10 md:-translate-y-4"
                : "bg-white/5 text-cream border-white/10 backdrop-blur"
            }`}
            style={is360 ? { background: "linear-gradient(160deg, #8E1FF5 0%, #7714D9 45%, #4A0B98 100%)" } : undefined}
          >
            {plan.featured && (
              <div className="absolute -top-3 left-8 bg-hot text-cream font-display font-bold text-xs px-3 py-1 rounded-full rotate-[-3deg] z-10">
                ★ mais popular
              </div>
            )}
            {is360 && (
              <div className="absolute -top-3 left-8 bg-lime text-ink font-display font-bold text-xs px-3 py-1 rounded-full rotate-[-3deg] z-10">
                ✦ mais completo
              </div>
            )}
            {plan.name === "Start" && (
              <div data-testid="plan-promo-badge" className="absolute -top-6 -right-6 w-28 h-28 spin-slow pointer-events-none z-10">
                <svg viewBox="0 0 100 100" className="w-full h-full">
                  <defs>
                    <path id="startPromoCircle" d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" />
                  </defs>
                  <circle cx="50" cy="50" r="48" fill="#FF3D7F" />
                  <text fill="#0A0A0A" fontFamily="Anton, sans-serif" fontSize="8.5" fontWeight="800" letterSpacing="0.4">
                    <textPath href="#startPromoCircle">· ANÁLISE DE CARREIRA · GRÁTIS · </textPath>
                  </text>
                  <text x="50" y="47" textAnchor="middle" fill="#0A0A0A" fontFamily="Anton, sans-serif" fontSize="11" fontWeight="900">OFERTA</text>
                  <text x="50" y="60" textAnchor="middle" fill="#0A0A0A" fontFamily="Anton, sans-serif" fontSize="9" fontWeight="700">grátis ✦</text>
                </svg>
              </div>
            )}
            <h3 className="font-display font-extrabold text-4xl">{plan.name}</h3>
            <div className="mt-4 mb-2 font-display font-black text-5xl">{plan.price}</div>
            {plan.priceNote && (
              <div className={`font-body text-xs uppercase tracking-widest mb-2 ${plan.featured ? "text-ink/60" : "text-cream/50"}`}>
                {plan.priceNote}
              </div>
            )}
            <p className={`font-body text-sm mb-6 ${plan.featured ? "text-ink/70" : "text-cream/60"}`}>{plan.summary}</p>
            <ul className="space-y-3 flex-1 mb-8">
              {plan.features.map((f) => (
                <li key={f} className="flex items-start gap-3 font-body text-sm">
                  <span className={`mt-0.5 shrink-0 inline-flex w-5 h-5 items-center justify-center rounded-full ${plan.featured ? "bg-ink text-lime" : "bg-lime text-ink"}`}>
                    <Check size={12} strokeWidth={3} />
                  </span>
                  <span>{f}</span>
                </li>
              ))}
            </ul>
            <a
              href="#booking"
              data-testid={`plan-${plan.name.toLowerCase()}-cta`}
              className={`inline-flex items-center justify-center gap-2 font-display font-bold text-sm px-6 py-4 rounded-full transition-colors ${
                plan.featured
                  ? "bg-ink text-cream hover:bg-hot"
                  : "bg-lime text-ink hover:bg-hot hover:text-cream"
              }`}
            >
              Começar {plan.name} ↗
            </a>
          </div>
          );
        })}
      </div>
    </section>
  );
}
